import { motion, useReducedMotion } from "framer-motion";

/* Real HUMN app screens (supplied by the product team) rendered inside device frames */

const AppImage = ({ src, alt, pan = false }) => {
  const reduce = useReducedMotion();
  return (
    <div className="w-full h-full overflow-hidden bg-[#07040f]">
      <motion.img
        src={`/app-screens/${src}.jpg`}
        alt={alt}
        loading="lazy"
        className="w-full h-full object-cover object-top"
        animate={pan && !reduce ? { y: ["0%", "-6%", "0%"] } : {}}
        transition={{ duration: 16, repeat: Infinity, ease: "easeInOut" }}
        style={{ height: pan ? "112%" : "100%" }}
      />
    </div>
  );
};

export const AIChatScreen = ({ animate = true }) => (
  <AppImage src="ai-chat" alt="HUMN AI screen — What do you want to make happen?" />
);

export const FeedScreen = ({ animate = true }) => (
  <AppImage src="feed" alt="HUMN adaptive feed with stories, trending creators and SLM (HumnAi) cards" pan={animate} />
);

export const RichSLMScreen = ({ animate = false }) => (
  <AppImage src="rich-slm" alt="Rich SLM (HumnAi) card with creator media, credits and CTA" />
);

export const MicroSLMScreen = ({ animate = false }) => (
  <AppImage src="micro-slm" alt="Micro SLM (HumnAi) — a short intent card with a Respond CTA" />
);

export const StoriesScreen = ({ animate = false }) => (
  <AppImage src="slm-grid" alt="Stories and SLM (HumnAi) collection grid of real moments" pan={animate} />
);

export const SearchScreen = ({ animate = false }) => (
  <AppImage src="discovery" alt="Search and discovery — SLM (HumnAi) workspace with AI summary" />
);

export const CommunitiesScreen = ({ animate = false }) => (
  <AppImage src="messages" alt="Communities and conversations around shared Happenings" />
);

export const HappeningsScreen = ({ animate = false }) => (
  <AppImage src="happenings" alt="My Happenings — actions, requests and progress" />
);

export const ProfileScreen = ({ animate = false }) => (
  <AppImage src="profile" alt="HUMN profile with identity verification, Happenings and SLMs (HumnAi)" />
);

export const CreditsScreen = ({ animate = false }) => (
  <AppImage src="wallet" alt="HUMN Wallet — available, earned and withdrawable credits" />
);

export const ActionCenterScreen = ({ animate = false }) => (
  <AppImage src="action-center" alt="Action Center — every item is a decision, not a notification" />
);
